import { render } from "./Todos.vue?vue&type=template&id=04dbbfd7&scoped=true"
import script from "./Todos.vue?vue&type=script&lang=js"
export * from "./Todos.vue?vue&type=script&lang=js"

import "./Todos.vue?vue&type=style&index=0&id=04dbbfd7&scoped=true&lang=css"

import exportComponent from "/var/www/html/lr-courses/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dbbfd7"]])

export default __exports__